"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _util = require("@bento-core/util");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var AboutCard = function AboutCard(_ref) {
  var searchText = _ref.searchText,
    data = _ref.data,
    classes = _ref.classes,
    index = _ref.index;
  var results = data.text.map(function (result) {
    return result.replaceAll('$', '');
  });
  function getHighlightedText(text, highlight) {
    // Split on highlight term and include term into parts, ignore case
    var textString = text.reduce(function (searchResults, currentString, currentIndex) {
      var newResults = searchResults;
      if (currentString.endsWith('.') || currentIndex >= text.length - 1) {
        newResults = "".concat("".concat(newResults, " ").concat(currentString));
      } else {
        newResults = "".concat("".concat(newResults, " ").concat(currentString), " ... ");
      }
      return newResults;
    }, '');
    var parts = textString.split(new RegExp("(".concat(highlight, ")"), 'gi'));
    return /*#__PURE__*/_react.default.createElement("span", null, ' ', parts.map(function (part, i) {
      return /*#__PURE__*/_react.default.createElement("span", {
        id: i,
        style: part.toLowerCase() === highlight.toLowerCase() ? {
          color: '#0467BD'
        } : {}
      }, part);
    }), ' ');
  }
  return /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    container: true,
    className: classes.card,
    id: "global_search_card_".concat(index)
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 1,
    className: classes.indexContainer
  }, index + 1), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 11,
    className: classes.propertyContainer
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("span", {
    className: classes.detailContainerHeader
  }, "ABOUT"), /*#__PURE__*/_react.default.createElement("span", {
    className: classes.cardTitle
  }, data.title)), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.text
  }, getHighlightedText(results, searchText)), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.linkText
  }, /*#__PURE__*/_react.default.createElement(_util.Anchor, {
    link: data.page,
    text: "".concat(window.location.origin).concat(data.page),
    classes: classes
  }))));
};
var styles = function styles(theme) {
  return {
    linkText: {
      fontFamily: 'Nunito',
      color: theme.palette.text.link,
      textDecoration: 'none'
    },
    indexContainer: {
      padding: '18px 0px 18px 18px',
      color: '#747474',
      fontFamily: 'Inter',
      fontSize: '13px'
    },
    propertyContainer: {
      padding: '16px 16px 16px 0px',
      borderBottom: '2px solid #E7EEF5'
    },
    cardTitle: {
      color: theme.palette.text.link,
      textDecoration: 'none',
      fontSize: '16px',
      fontFamily: 'Nunito',
      paddingLeft: '9px',
      verticalAlign: 'middle'
    },
    detailContainerHeader: {
      textTransform: 'uppercase',
      padding: '2px 8px',
      backgroundColor: '#ECC28B',
      color: '#000000',
      fontFamily: 'Nunito',
      fontSize: '12px',
      fontWeight: '400',
      letterSpacing: '0.9px',
      verticalAlign: 'middle',
      borderRadius: '4px'
    }
  };
};
var _default = (0, _core.withStyles)(styles, {
  withTheme: true
})(AboutCard);
exports.default = _default;